import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Batches from './pages/Batches';
import Notices from './pages/Notices';
import Courses from './pages/Courses';
import Applications from './pages/Applications';
import Videos from './pages/Videos';
import SuccessStories from './pages/SuccessStories';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-14 w-14 border-4 border-red-700 border-t-transparent mx-auto mb-4" />
        <p className="text-slate-500 text-sm">Loading...</p>
      </div>
    </div>
  );
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login"           element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/dashboard"       element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/batches"         element={<PrivateRoute><Batches /></PrivateRoute>} />
      <Route path="/notices"         element={<PrivateRoute><Notices /></PrivateRoute>} />
      <Route path="/courses"         element={<PrivateRoute><Courses /></PrivateRoute>} />
      <Route path="/applications"    element={<PrivateRoute><Applications /></PrivateRoute>} />
      <Route path="/videos"          element={<PrivateRoute><Videos /></PrivateRoute>} />
      <Route path="/success-stories" element={<PrivateRoute><SuccessStories /></PrivateRoute>} />
      <Route path="*"                element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3000, style: { fontSize:'14px' } }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
